import { Navigate, useLocation } from "react-router-dom";
import { globalStorage } from "../helpers";
import { hasRoutePermission } from "../config/permissions";

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const location = useLocation();
  
  // Allow access to all routes without permission checking
  // Commenting out permission checks to show all menus
  /*
  // Get user permissions from storage
  const userData = globalStorage.getItem("fin_user_data");
  const userPermissions = userData?.permissions || [];
  
  // Check if user has required permissions
  const hasPermission = requiredPermissions.length === 0 || 
    requiredPermissions.some(permission => userPermissions.includes(permission));
  
  // Check if user has permission for the current route path
  const hasRouteAccess = hasRoutePermission(userPermissions, location.pathname);
  
  if (!hasPermission || !hasRouteAccess) {
    // Redirect to dashboard with no access message
    return <Navigate to="/beranda" state={{ 
      from: location, 
      error: "Anda tidak memiliki akses ke halaman ini" 
    }} replace />;
  }
  */
  
  return children;
};

export default ProtectedRoute;
